/**
 * circle dependence
 *
 * @author Shigq
 * @date 2021/11/22 15:26
 */
var _ui = require('./modules/ui')
var _utils = require('./modules/utils')

var dep = {
	ui: _ui,
	utils: _utils
}

console.log('dep-private init', dep)

module.exports = dep
